<button class="btn btn-danger btn-block" [disabled]="!isEnabled || isBlocked || isLocked" (click)="cancelTicket()" title="{{ tooltipTitle }}" #button>
    <i class="fas fa-times" #icon></i>
    <span class="element-text">{{ 'cancel' | translate }}</span>
</button>